import { Jobs } from '@energy-stacks/fleet/feature-jobs';
import { JobModel } from '@energy-stacks/fleet/feature-jobs-data';
import { DateRange } from '@energy-stacks/core/date-range-picker';

interface JobsStepProps {
  onJobsSelected: (jobIds: JobModel[]) => void;
  selectedJobs: JobModel[] | undefined;
  defaultDateRange: DateRange;
  dateRange: DateRange;
  onDateRangeChange: (dateRange: DateRange) => void;
}

export const JobsStep: React.FC<JobsStepProps> = ({
  onJobsSelected,
  dateRange,
  defaultDateRange,
  onDateRangeChange,
  selectedJobs,
}) => {
  return (
    <Jobs
      selectedJobs={selectedJobs}
      onJobsSelected={onJobsSelected}
      preselectedJobStatusFilters={['TO_DO']}
      defaultDateRange={defaultDateRange}
      dateRange={dateRange}
      onDateRangeChange={(range) =>
        onDateRangeChange(range ?? defaultDateRange)
      }
    />
  );
};
